import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
  ValidatorConstraint,
  ValidatorConstraintInterface,
  isEmail,
} from 'class-validator';
import { ErrorCode } from '../../../constants/src';

@ValidatorConstraint({ name: '_isEmail', async: false })
export class IsEmailConstraint implements ValidatorConstraintInterface {
  validate(value: unknown, args: ValidationArguments) {
    return typeof value === 'string' && isEmail(value);
  }

  defaultMessage(args: ValidationArguments) {
    const [errorCode] = args.constraints;

    return JSON.stringify({
      code: errorCode,
      message: `${args.property} must be a valid email address`,
      path: args.property,
      params: {
        currentValue: args.value,
      },
    });
  }
}

export function IsEmail(
  errorCode: ErrorCode = ErrorCode.INVALID_EMAIL,
  validationOptions?: ValidationOptions,
) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: '_isEmail',
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [errorCode],
      validator: IsEmailConstraint,
    });
  };
}
